import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { SellerReturnPolicy } from '~/models/marketplace/seller'

@containerScoped()
export default class MarketplaceSellerService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  getReturnPolicies(
    sellerId: string | number
  ): Promise<{ returnPolicy: SellerReturnPolicy }> {
    return this.requestBuilder
      .request('get', `/api/market/seller/${sellerId}/policies/`)
      .send()
  }
}
